module.exports = __webpack_public_path__ + "static/media/comment-svgrepo-com (5).3a9c0fa1.svg";